/* unused-imports/no-unused-imports */
import api from "api";
import {
	clearSignupData,
	processFormData,
	showToast,
} from "../utils/helpers";
import { navigate } from "@reach/router";
import { toFormData } from "axios";
import { apiV1 } from "api-v2";
import { getCookie, removeAllCookie, setCookie } from "utils/cookiesHelper";
import { FeatureFlagType } from "newui/features/Auth/types/FeatureFlag.type";
import store from "newui/store";
import {
	authenticateTwoFactor,
	disableTwoFactor,
	enableTwoFactor,
	logoutUser,
	setCurrentCompany,
	setCurrentUser,
	setSignupDetails,
} from "newui/features/Auth/authSlice";

// TODO: Replace all uses with api-v1 or v2
function getApiWithToken() {
	return api;
}

export const signup = (
	id,
	first_name,
	last_name,
	email,
	password,
	agreed,
	setSubmitting
) => {
	return async (dispatch) => {
		const formData = processFormData({
			id: id,
			first_name: first_name,
			last_name: last_name,
			email: email,
			password: password,
			isAgree: agreed,
		});
		try {
			const user = await api
				.post("auth/users/create", {
					body: formData,
				})
				.json();

			if (user.success === true) {
				await dispatch(setSignupDetails(user.user));
				return user;
			} else {
				setSubmitting(false);
				return user;
			}
		} catch (e) {
			const error = await e.response.json();
			const errorMessages = error.errors?.password;
			const errorMessage =
				errorMessages.length < 2
					? errorMessages[0]
					: errorMessages[errorMessages.length - 1];
			showToast(errorMessage || error.error, "Error");
		}
	};
};

export const saveBusinessDetails = (
	id,
	company_id,
	business_name,
	phone,
	abn,
	setSubmitting
) => {
	return async (dispatch) => {
		const formData = processFormData({
			id: id,
			company_id: company_id,
			business_name: business_name,
			phone: phone,
			abn: abn,
		});
		try {
			const user = await api
				.post("auth/business/create", {
					body: formData,
				})
				.json();

			if (user.success === true) {
				await dispatch(setSignupDetails(user.user));
				return user;
			} else {
				setSubmitting(false);
				return user;
			}
		} catch (e) {
			const error = await e;
			if (error.response.status === 404) {
				let errorMessage =
					"Please refresh the page and start the process again. If you continue to have issues, feel free to email us at support@procuracon.com.au";
				showToast(errorMessage, "Error");
				clearSignupData();
				return error.response.status;
			} else showToast(error.response, "Error");
			showToast(error.error, "Error");
		}
	};
};

export const completeRegistration = (values, setSubmitting) => {
	return async (dispatch) => {
		const formData = processFormData({
			id: values.id,
			account_type_id: parseInt(values.account_type_id),
			profile_type_id: values.profile_type_id
				? parseInt(values.profile_type_id)
				: null,
			payment_method: values.payment_method,
			token_id: values.token_id,
			discount_code: values.discount_code,
			automatic_subscription: values.automatic_subscription,
		});
		try {
			const res = await api
				.post("auth/users/complete-registration", {
					body: formData,
					timeout: false,
				})
				.json();
			if (res.success === true) {
				clearSignupData();
				await dispatch(setSignupDetails(null));
				showToast("Registration Completed", "Success", true);
				return res;
			} else {
				setSubmitting(false);
				return res;
			}
		} catch (e) {
			const error = await e;
			if (error.response.status === 404) {
				let errorMessage =
					"Please refresh the page and start the process again. If you continue to have issues, feel free to email us at support@procuracon.com.au";
				showToast(errorMessage, "Error");
				clearSignupData();
				return error.response.status;
			} else showToast(error.response, "Error");
		}
	};
};

export const forgotPassword = (values, setSubmitting) => {
	return async () => {
		const formData = processFormData(values);

		try {
			const status = await api
				.post("auth/forget-password", { body: formData })
				.json();

			if (status.status) {
				setSubmitting(false);
				return status;
			} else {
				setSubmitting(false);
				return status;
			}
		} catch (e) {
			const error = await e.response.json();
			console.log(error.error);
		}
	};
};

export const resetPassword = (values, setSubmitting) => {
	return async () => {
		const formData = processFormData(values);

		try {
			const status = await api
				.post("auth/reset-password", { body: formData })
				.json();

			if (status.status) {
				showToast("Reset Password. Redirecting now.", "Success", true);
				navigate("/login");
			} else {
				showToast(status.message, "Error");
			}
		} catch (e) {
			const error = await e.response.json();
			const errorMessages = error.errors?.password;
			const errorMessage =
				errorMessages.length < 2
					? errorMessages[0]
					: errorMessages[errorMessages.length - 1];
			showToast(errorMessage || error.error, "Error");
		}

		setSubmitting(false);
	};
};

export const applyDiscount = (id) => {
	return async () => {
		try {
			const result = await api
				.get(`apply-discount/${encodeURIComponent(id)}`)
				.json();
			return result;
		} catch (e) {
			const error = await e.response.json();
			showToast(error.error, "Error");
		}
	};
};

export const createCompanyUser = (values) => {
	return async () => {
		const formData = processFormData(values);
		try {
			const result = await apiV1
				.post("users/create-company-user", formData,
				);
			if (result.data?.success === true) {
				return result.data;
			} else {
				showToast(result.data?.message, "Error");
				return result.data;
			}
		} catch (e) {
		}
	};
};

export const verifyEmail = (email, token) => {
	return async (dispatch) => {
		(async () => {
			const formData = processFormData({ email: email, code: token });

			try {
				const res = await getApiWithToken()
					.post("auth/verify-email", { body: formData, timeout: false })
					.json();
				if (res.status === true) {
					// TODO: replace with correct logic now no access_token
					const acc_token = false;
					if (acc_token) {
						const user = await getApiWithToken()
							.get("auth/user-profile")
							.json();

						await dispatch(setCurrentUser(user.data));
						showToast("Email Verified. Redirecting now.", "Success", true);
					} else
						showToast("Email has been Verified. Login Now", "Success", true);
					navigate("/login");
				} else {
					showToast(res.message, "Error");

					// TODO: need to replace this with correct logic now we have no access token
					const access_token = false;
					if (access_token) navigate("/verify-email", { replace: true });
					else navigate("/login", { replace: true });
				}
			} catch (e) {
				const error = await e.response.json();
				showToast(error.error, "Error");
				navigate("/login", { replace: true });
			}
		})();
	};
};

/**
 * TODO: need to ensure we ar eloading profile after this
 * @param {*} token 
 * @param {*} twoFactorPassed 
 * @returns 
 */
export const setAccessToken = (token, twoFactorPassed) => {
	return async (dispatch) => {
		(async () => {
			await dispatch(
				authenticateTwoFactor({
					two_factor_enabled: twoFactorPassed,
					two_factor_verified: twoFactorPassed,
				})
			);
			// await dispatch(getCurrentUser());
		})();
	};
};

export const guestSignup = (values, setSubmitting) => {
	return async () => {
		values.password_confirmation = values.password;
		const formData = processFormData(values);
		try {
			const res = await apiV1.post("guest/register", formData);
			if (res.status === 200) {
				showToast(res?.data?.message, "Success", true);
				navigate("/thank-you");
			} else {
				setSubmitting(false);
				return res;
			}
		} catch (error) {
			setSubmitting(false);
			throw error;
		}
	};
};

export const shareProfile = (token) => {
	return async () => {
		try {
			const result = await apiV1.get(`auth/share-profile?invitetoken=${token}`);
			return result?.data;
		} catch (e) {
			const error = await e.response.json();
			showToast(error.error, "Error");
			return error;
		}
	};
};

export const upgradeAccount = (email) => {
	return async (dispatch) => {
		(async () => {
			try {
				localStorage.clear();
				navigate("/signup", { replace: true, state: { email: email } });
				await dispatch(logoutUser());
			} catch (e) {
				const error = await e.response?.json();
				showToast(error?.error, "Error");
			}
		})();
	};
};

export const enablingTwoFactor = async () => {
	try {
		const result = await getApiWithToken().get("2fa/two-factor-code").json();
		if (result.status) {
			return result.data;
		} else {
			showToast(result.message, "Error");
		}
	} catch (e) {
		const error = e?.response?.data?.errors?.code[0] || "Failed to enable 2FA";
		showToast(error, "Error");
		return error;
	}
};

export const submitTwoFactorCode = async (values) => {
	const data = toFormData({ code: values });
	try {
		const result = await getApiWithToken()
			.post("2fa/two-factor-confirm", { body: data })
			.json();
		if (result.success) {
			showToast("2FA enabled", "Success", true);
			localStorage.setItem("two_factor_enabled", true);
			localStorage.setItem("two_factor_verified", true);
			return result;
		} else {
			showToast("Invalid Code", "Error");
		}
	} catch (e) {
		const error = e?.response?.data?.errors?.code[0] || "Failed to enable 2FA";
		showToast(error, "Error");
	}
};

export const enableTwoFactorAuthentication = () => {
	return async (dispatch) => {
		dispatch(enableTwoFactor());
	};
};

export const authTwoFactorLogin = (values, isBackupCode) => {
	return async (dispatch) => {
		const formData = processFormData({ code: values });
		try {
			const result = await getApiWithToken()
				.post(
					isBackupCode
						? "2fa/two-factor-recovery-codes"
						: "2fa/two-factor-confirm",
					{ body: formData }
				)
				.json();
			if (result.success) {
				const user = result;

				localStorage.setItem("two_factor_verified", true);

				const userProfile = await getApiWithToken()
					.get("auth/user-profile")
					.json();

				await dispatch(
					authenticateTwoFactor({
						two_factor_enabled: true,
						two_factor_verified: true,
					})
				);
				await dispatch(setCurrentUser(userProfile.data));
			} else {
				showToast(result.message, "Error");
			}
		} catch (e) {
			const error = e?.response?.data?.errors?.code[0] || "Invalid Code";
			showToast(error, "Error");
			return error;
		}
	};
};

export const deactivateTwoFactor = () => {
	return async (dispatch) => {
		try {
			const result = await getApiWithToken()
				.post("2fa/two-factor-disable")
				.json();
			if (result.status) {
				await dispatch(disableTwoFactor());
				localStorage.setItem("two_factor_enabled", false);
				localStorage.setItem("two_factor_verified", false);
				showToast(result.message, "Success");
				return result.data;
			} else {
				showToast(result.message, "Error");
			}
		} catch (e) {
			const error =
				e?.response?.data?.errors?.code[0] || "Failed to disable 2FA";
			showToast(error, "Error");
			return error;
		}
	};
};

export const continueTwoFactorSetup = (user) => {
	return async (dispatch) => {
		localStorage.setItem("two_factor_verified", true);

		const userProfile = await getApiWithToken().get("auth/user-profile").json();

		await dispatch(
			authenticateTwoFactor({
				two_factor_enabled: true,
				two_factor_verified: true,
			})
		);
		await dispatch(setCurrentUser(userProfile.data));
	};
};

export const getBackupCodes = async () => {
	try {
		const response = await getApiWithToken()
			.get("2fa/two-factor-recovery-codes")
			.json();
		if (response.status) {
			return response.data;
		} else {
			showToast(response.message, "Error");
		}
	} catch (e) {
		console.log(e);
	}
};

export const checkAccessToken = async () => {
	const status = await getApiWithToken().post("auth/check-access-token").json();
	return status.status;
};

export const acceptTermsAndConditions = () => async (dispatch) => {
	const formData = new FormData();
	formData.append("accept", 1);
	const result = await getApiWithToken()
		.post("auth/accept-term", {
			body: formData,
		})
		.json();

	if (result.status) {
		await dispatch(setCurrentCompany(result?.data));

		const termsFlag = result.data?.feature_flags?.find(
			(item) => item.id === FeatureFlagType.TERMS_AND_CONDITIONS
		);

		if (!termsFlag) {
			return result;
		}

		const state = store.getState();

		const newUser = { ...state.auth.user };

		if (!newUser) {
			return result;
		}

		const new_feature_flags = newUser.feature_flags
			? [...newUser.feature_flags]
			: [];
		new_feature_flags.push(termsFlag);
		newUser.feature_flags = new_feature_flags;

		await dispatch(setCurrentUser({ ...newUser }));

		return result;
	} else {
		throw new Error(result.message);
	}
};

export const identifyUser = async (email) => {
	try {
		const response = await api.get(`identify-user/${email}`).json();
		if (response.success) {
			return response.data;
		} else {
			showToast(response.message || "Failed to identify user type.", "Error");
			return null;
		}
	} catch (e) {
		console.error("Identify User Error:", e);
		const error = await e.response?.json();
		showToast(
			error?.message ||
			error?.error ||
			"An error occurred while checking the email.",
			"Error"
		);
		throw e;
	}
};
